import { lazy } from 'react';

// Lazy load heavy components to reduce initial bundle size
export const LazyZtartDDF = lazy(() => import('@/pages/ZtartDDF'));
export const LazyWallet = lazy(() => import('@/pages/Wallet'));
export const LazyIndex = lazy(() => import('@/pages/Index'));

// Lazy load QR components
export const LazyQRCodes = lazy(() => import('@/pages/QRCodes'));
export const LazyQREdit = lazy(() => import('@/pages/QREdit'));

// Lazy load profile components
export const LazyProfile = lazy(() => import('@/pages/Profile'));

// Lazy load contact components
export const LazyContacts = lazy(() => import('@/pages/Contacts'));

// Lazy load analytics components (now General Analytics)
export const LazyAnalytics = lazy(() => import('@/pages/GeneralAnalytics'));

// Lazy load nearby components
export const LazyNearbyUsers = lazy(() => import('@/pages/NearbyUsers'));

// Lazy load account components
export const LazyAccount = lazy(() => import('@/pages/Account'));

// Lazy load auth components
export const LazyAuth = lazy(() => import('@/pages/Auth'));

// Lazy load quick tip components
export const LazyQuickTip = lazy(() => import('@/pages/QuickTip'));

// Lazy load transactions components
export const LazyTransactions = lazy(() => import('@/pages/Transactions')); 